import { omitUndefined } from '../omitUndefined';

export const mergeDefined = <T extends Record<string, any>, R = Partial<T>>(left?: T, right?: T) =>
  Object.assign(omitUndefined(left), omitUndefined(right)) as R;
